import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { getFaqDetails } from "../../../../redux/actions/campaignActions";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../Others/Aboutus/Add/addnew.scss";

const InvestorFaqEdit = () => {
  const [contents, setContents] = useState("");
  const [loading, setLoading] = useState(false);
  const id = useParams();

  let token = localStorage.getItem("accessToken");
  let type = "investor";
  const navitage = useNavigate();
  const dispatch = useDispatch();
  const faqView = useSelector((state) => state.faqView);
  const { faq } = faqView;

  useEffect(() => {
    dispatch(getFaqDetails(token, id, type));
  }, [dispatch]);

  useEffect(() => {
    if (faqView) {
      if (faqView?.loading !== undefined) {
        setLoading(faqView?.loading);
      }
    }
  }, [faqView]);

  useEffect(() => {
    if (faq) {
      setValue("en_question", faq?.data?.en_question);
      setValue("fr_question", faq?.data?.fr_question);
      setValue("it_question", faq?.data?.it_question);
      setValue("es_question", faq?.data?.es_question);
      setValue("pl_question", faq?.data?.pl_question);
      setValue("display_order", faq?.data?.display_order);
      setValue("pl_answer", faq?.data?.pl_answer);
      setValue("en_answer", faq?.data?.en_answer);
      setValue("fr_answer", faq?.data?.fr_answer);
      setValue("it_answer", faq?.data?.it_answer);
      setValue("es_answer", faq?.data?.es_answer);
    }
  }, [faq]);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div>
            <div className="modal-content-title">View FAQ</div>
            <p>&nbsp;</p>
            <form className="faq-form">
              <div className="custome-form-group">
                <label>English Question* : </label>
                <input
                  type="text"
                  name="en_question"
                  {...register("en_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.en_question && (
                  <div className="invalid-feedback">
                    {errors.en_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>French Question* :</label>
                <input
                  type="text"
                  name="fr_question"
                  {...register("fr_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.fr_question && (
                  <div className="invalid-feedback">
                    {errors.fr_question.message}
                  </div>
                )}
              </div>

              <div className="custome-form-group">
                <label>Italian Question* :</label>
                <input
                  type="text"
                  name="it_question"
                  {...register("it_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.it_question && (
                  <div className="invalid-feedback">
                    {errors.it_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Spanish Question* :</label>
                <input
                  type="text"
                  name="es_question"
                  {...register("es_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.es_question && (
                  <div className="invalid-feedback">
                    {errors.es_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Polish Question* :</label>
                <input
                  type="text"
                  name="pl_question"
                  {...register("pl_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.pl_question && (
                  <div className="invalid-feedback">
                    {errors.pl_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Display Order</label>
                <input
                  type="text"
                  name="display_order"
                  {...register("display_order", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                  readOnly
                />
                {errors.display_order && (
                  <div className="invalid-feedback">
                    {errors.display_order.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>English Answer* :</label>

                {getValues("en_answer") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    data={
                      getValues("en_answer") !== undefined
                        ? getValues("en_answer")
                        : "loading"
                    }
                    name="en_answer"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("en_answer", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>French Answer* :</label>
                {getValues("fr_answer") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    data={
                      getValues("fr_answer") !== undefined
                        ? getValues("fr_answer")
                        : "loading"
                    }
                    name="fr_answer"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("fr_answer", editor.getData());
                    }}
                    readOnly
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Italian Answer* :</label>
                {getValues("it_answer") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    data={
                      getValues("it_answer") !== undefined
                        ? getValues("it_answer")
                        : "loading"
                    }
                    name="it_answer"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("it_answer", editor.getData());
                    }}
                    readOnly
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Spanish Answer* :</label>
                {getValues("es_answer") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    data={
                      getValues("es_answer") !== undefined
                        ? getValues("es_answer")
                        : "loading"
                    }
                    name="es_answer"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("es_answer", editor.getData());
                    }}
                    readOnly
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Polish Answer* :</label>
                {getValues("pl_answer") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    data={
                      getValues("pl_answer") !== undefined
                        ? getValues("pl_answer")
                        : "loading"
                    }
                    name="pl_answer"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("pl_answer", editor.getData());
                    }}
                    readOnly
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorFaqEdit;
